const initialState = {
  show: {
    isLoading: false,
    data: {},
    error: '',
  },
};

export default initialState;
